export enum FormFactor {
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile',
}
